import(/* webpackMode: "eager" */ "/usr/src/app/client-portal/src/app/[lang]/error.tsx")